import { Message } from "hireart-components";

const FormError = ({ error }) => {
  if (error.length > 0) {
    return (
      <Message
        type="error"
        content={typeof error === "object" ? error[0] : error}
        icon="exclamation triangle"
      />
    );
  }
  return null;
};

export default FormError;
